export default "__VITE_ASSET__cbbfb4d0__"